import { Card } from "./card";

export class PaymentDetails {
  public companyId: string = "";
  public taxId: string = "";
  public postalCode: string = "";
  public name: string = "";
  public address: string = "";
  public country: string = "";
  public state: string = "";
  public card: Card;
}